export const en = {
    brandlift: 'Research',
    'budget-limit-with-currency': 'Budget, {currency}',
    budgetLimit: 'Budget',
    'campaign-type': 'Campaign type',
    default: 'Manual management',
    goals: 'Conversions',
    id: 'Id',
    name: 'Name',
    platform: 'Platform',
    settings: 'Settings',
    status: 'Status',
    strategy: 'Strategy',
    sum: 'Remaining',
    'sum-with-currency': 'Remaining, {currency}',
    type: 'Type'
};
